import React from 'react';

import './delete-transfer-card-form.scss';
import ModalForm from '../_global/modal-form/modal-form';

const DeleteTransferCardForm = ({ onSubmit, closeForm, cardSelection }) => {
  const handleSubmit = () => {
    const cardNumbers =  selectedCardNumbers();
    onSubmit && onSubmit(cardNumbers);
  };

  const selectedCardNumbers = () => {
    return Object.values(cardSelection).filter(x => x.isSelected).map((x) => x.cardNumber);
  };

  return <>
    <ModalForm
      title="Delete Transfer"
      closeForm={closeForm}
      submitClick={handleSubmit}
      submitLabel="Yes"
      inModal={false}
      canSubmit
    >
      <div className={'delete-transfer'}>
        <h4>Card Number</h4>
        <div>
          {
            (Object.values(cardSelection).filter(v => v.isSelected).length > 1) ?
              'Multiple selected' :
              selectedCardNumbers()
          }
        </div>
        <h4>Are you sure?</h4>
        <div>Are you sure you want to delete this transfer request?</div>
      </div>
    </ModalForm>
  </>;
};

export default DeleteTransferCardForm;
